function checkMax(){
	$(".global-plus").each(function(){
		q = $(this).prev();
		var value = parseInt(q.val(), 10);
		value = isNaN(value) ? 0 : value;
		if($(this).attr("data-max"))
		{
			max = parseInt($(this).attr("data-max"));
			if(value == max)
			{
				$(this).attr("disabled",true);
			}
			else
			{
				$(this).attr("disabled",false);
			}
		}
		else
		{
			$(this).attr("disabled",false);
		}
	});
}


function reloadImages(){
	$(".global-switch-image").each(function(){
		if($(window).width() < 768)
		{
			$(this).attr("src",$(this).attr("data-mobile"));
		}
		else
		{
			$(this).attr("src",$(this).attr("data-desktop"));
		}
	});
}

function adjustProductHeight(elem)
{
	if($(window).width() >= 768)
	{
		var max = 0;

		$(elem).find(".collection-product-vendor").css("height","auto").each(function(){
			if($(this).outerHeight() > max)
				max = $(this).outerHeight();
		}).css("height",max);

		var max = 0;

		$(elem).find(".collection-product-title").css("height","auto").each(function(){
			if($(this).outerHeight() > max)
				max = $(this).outerHeight();
		}).css("height",max);
	}
	else
	{
		$(elem).find(".collection-product-vendor,.collection-product-title").css("height","auto");
	}
}

function refreshCart(show = true){
	$(".cart-fixed-con .global-loading").show();
	$.ajax({
		url : '/cart.js',
		type : 'GET',
		dataType: 'json',
		success: function(cart){
			//console.log(cart);
			cart_bundle = [];
			line_items = cart.items;
			qty = 0;
			cartItems = [];
			fbCartItems = [];
			totalValue = 0;
			num_items = 0;
			for(i = 0; i < line_items.length; i++)
			{
				item = line_items[i];

				// Re-create cartItems for push FB Pixel & TikTok Pixel
				let itemTitle = item.title;
				if(!(item.title.includes("Default") || item.title == item.product_title)) {
					itemTitle += " - "+item.title.replace(item.product_title+" - ", "");
				}
				cartItems.push({
					content_id: ''+item.variant_id,
					content_type: 'product',
					content_name: itemTitle,
					quantity: item.quantity,
					price: parseFloat(Shopify.formatMoney(item.price).toString().replace(",", "").replace("$",""))
				});
				fbCartItems.push({
					id: item.variant_id,
					name: itemTitle,
					sku: item.sku,
					quantity: item.quantity
				});
				num_items += item.quantity;
				totalValue += parseFloat(Shopify.formatMoney(item.final_line_price).toString().replace(",", "").replace("$",""));

				if(item.properties != null && item.properties["_handle"] != undefined)
				{
					if(! cart_bundle.includes(item.properties["_handle"]))
					{
						qty += item.quantity;
						cart_bundle.push(item.properties["_handle"]);
					}
				}
				else
				{
					qty += item.quantity;
				}
			}
			$(".cart_count").html(qty);
			$(".cart_total").html(Shopify.formatMoney(cart.total_price));
			// $(".cart_count").html(cart.item_count);
			// $(".cart_total").html(Shopify.formatMoney(cart.total_price));
		}
	});
	if(show)
	{
		$.get('/cart?view=json', function (cart, textStatus) {
			$("#cart-panel-content").html(cart);
			fixedCart();
			$(".cart-fixed-con .global-loading").hide();
			showCart();
		});
	}
	else
	{
		$.get('/cart?view=json', function (cart, textStatus) {
			$("#cart-panel-content").html(cart);
			fixedCart();
			$(".cart-fixed-con .global-loading").hide();
		});
	}
	$.get('/cart?view=content', function (cart, textStatus) {
		$("#cart-page-content").html(cart);
	});
}

function showCart(){
	$('body').css('overflow', 'hidden');
	$('.global-overlay, .cart-fixed-con').addClass('shown');
}

$(function(){
	reloadImages();

	$(".global-video-link").magnificPopup({
		disableOn: 700,
		type: 'iframe',
		mainClass: 'mfp-fade',
		removalDelay: 160,
		preloader: false,
		iframe:{
			patterns:{
				youtube: {
					index: 'youtube.com/',
					id: 'v=', 
					src: '//www.youtube.com/embed/%id%?autoplay=1&rel=0' 
				},
				youtubeshort: {
					index: 'youtu.be/', 

					id: function(url) { 
						var slashPos = url.lastIndexOf('/'),
						vidId = url.substr(slashPos);

						return vidId; 
					},

					src: '//www.youtube.com/embed/%id%?autoplay=1&rel=0'
				}
			}
		},
		fixedContentPos: false
	});

	$('.header-cart').on('click', function(event) {
		event.preventDefault();
		showCart();
	});

	$('.global-overlay').on('click', function(){
		$(this).removeClass('shown');
		$('.cart-fixed-con').removeClass('shown');

		$('body').css('overflow', '');

	});


	$(".global-select-div-selection").change(function(){
		t = $(this);
		nn = t.find("option:selected").text();
		t.prev().text(nn);

		console.log('hi');
	});

});

function globalVideoSwitch()
{
	$(".product-features-video-div").each(function(){
		var tt = $(this);
		if($(window).outerWidth() >= 768)
		{
			tt.css("background-image","url("+tt.attr("data-image")+")");
		}
		else
		{
			tt.css("background-image","none");
		}
	});
}

function globalBannerSwitch()
{
	if($(window).outerWidth() < 768)
	{
		$(".global-banner-switch").each(function(){
			t = $(this);
			t.find('.global-banner-bg').css("background-image","none");
			t.find(".image").not('.product-image').remove();
			t.prepend("<img src='"+t.attr("data-mobile-image")+"' class='image'>");
		});

	}
	else if ($(window).width() >= 768)
	{
		
		$(".global-banner-switch").each(function(){
			t = $(this);
			img = t.attr("data-desktop-image");

			t.find(".image").not('.product-image').remove();
			t.find('.global-banner-bg').css("background-image","url(" + img + ")");
		});

	}
}


var ww, max, headerBar, shiftPos;

function scrollVar() {
	max = $('header').outerHeight();

	headerBar = 0;
	if (! $('.header-bar').hasClass('hide-mobile')) {
		headerBar = $('.header-bar').outerHeight() + $(".header-inner").outerHeight();
		$('.global-content-top-margin').css('padding-top', headerBar);		
	}
}

$(function(){
	globalBannerSwitch();
	globalVideoSwitch();
	scrollVar();
	ww = $(window).outerWidth();
});


//lazily load

$(window).on('resize',function(){
	if(ww != $(window).outerWidth())
	{
		scrollVar();
		reloadImages();
		globalBannerSwitch();
		globalVideoSwitch();
	}
});

$(window).on("orientationchange",function(){
	ww = $(window).outerWidth();
	scrollVar();
	reloadImages();
	globalBannerSwitch();
	globalVideoSwitch();
});

$(window).on('scroll mousewheel', function(){
	st = $(window).scrollTop();

	if (st >= max) {
		$('header').addClass('fixed');
		if (! $('.header-menu').is(':visible')) {
			$('.header-fixed-panel').addClass('visible');
			$('.header-search-panel').css('top', '');
		}
	} else {
		$('header').removeClass('fixed');
		if (! $('.header-menu').is(':visible')) {
			shiftPos = $(".header-bar").outerHeight();
			//$('.header-search-panel').css('top', shiftPos);
			$('.header-fixed-panel').removeClass('visible');
		}

	}
});


